
export const normalizeFilters = filters => {
  filters.forEach((filter, i) => {
    filter.filters.map(f => {
      f.selected = false;
      return f;
    });
    filter.numberOfFilters = filter.filters.length;
    i === 0 ? filter.isScore = true : filter.isScore = false;

    filter.filters.unshift({ value: 'All', selected: true });
  });
  return filters;
};

export const denormalizeFilters = filters => {
  filters.forEach(filter => {
    filter.filters.forEach(f => {
      delete f.selected;
    });
    delete filter.numberOfFilters;
    delete filter.isScore;
  });
  return filters;
};


// WEBPACK FOOTER //
// ./src/modules/filters/normalizeFilters.js